import { string } from "yup";

import { useTranslator } from "@eo-locale/react";

import sortBy from "lodash/sortBy";

import type { PlacesQuestion, Question } from "@/types";

import { CommonRadioButtonQuestion } from "@/storybook-components";

import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { setAnswer } from "@/redux/features/place-form/slice";

export const validate = async (
  value: string,
  question: Question
): Promise<string[]> => {
  let schema = string();
  if (question.required) {
    schema = schema.required();
  }
  try {
    await schema.validate(value);
    return [];
  } catch (err) {
    return err.errors;
  }
};

const RadioButtonQuestionComponent = (props: PlacesQuestion) => {
  const { question } = props;
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { answers, answerErrors } = useAppSelector((state) => state.placesForm);

  const error = answerErrors[question?.id] || "";

  const RadioButtonAnswer = answers[question?.id] || "";
  const { notes, required, id, questionOptions, question: title } = question;

  const handleChange = (value: string): void => {
    dispatch(
      setAnswer({
        questionId: question.id,
        answer: parseInt(value)
      })
    );
  };

  return (
    <CommonRadioButtonQuestion
      answer={RadioButtonAnswer}
      handleChange={handleChange}
      isRequired={required}
      answerStackSpacing={2}
      note={notes}
      questionId={id}
      isInvalid={error.length}
      errorMessage={error && translate(`errors.${error}`)}
      withErrorIcon={true}
      options={sortBy(questionOptions, (o) => o.sequence)}
      spacing={0}
      isHorizontal={false}
      questionLabel={title}
      questionLabelProps={{
        marginTop: 6
      }}
      answerProps={{
        minHeight: "0.75rem",
        backgroundColor: "white"
      }}
    />
  );
};

export default RadioButtonQuestionComponent;
